import React from 'react';
import RepoCard from '../dev/RepoCard';
import '../../styles/pages/DevPortfolio.css';

/**
 * Developer view of the portfolio home page. Code-focused list of
 * repositories, GitHub-inspired styling. v1: hand-curated metadata
 * (no runtime API fetch) — keeps the page fast and predictable.
 * When a repo's description, language, or url changes on GitHub,
 * update the REPOS list here and rebuild.
 *
 * Add repos by adding entries to REPOS. Each card auto-renders.
 */

const GITHUB_USERNAME = 'chidrupa99';
const GITHUB_PROFILE = `https://github.com/${GITHUB_USERNAME}`;

/** Stack — categorized by capability ("things I can do") rather than
 *  skill bucket ("words on a resume"). Each category maps to a kind of
 *  work a recruiter might be hiring for. Full skill list lives on the
 *  resume; the banner shows headline picks per category. */
const STACK = [
    {
        label: 'Frontend Development',
        items: 'React, TypeScript, JavaScript (ES6+), Tailwind CSS, Vite, Storybook',
    },
    {
        label: 'AI Integration',
        items: 'Claude API, Anthropic SDK, Cursor, Claude Code, Claude Figma MCP, REST APIs',
    },
    {
        label: 'Web Hosting',
        items: 'AWS S3, CloudFront, AWS Lambda, GitHub Pages, Custom Domains',
    },
    {
        label: 'Design Systems',
        items: 'Figma, Component Architecture, Light/Dark Theming, WCAG 2.1, Cross-Browser Compatibility',
    },
    {
        label: 'Workflow',
        items: 'Git, GitHub, VS Code, npm/yarn, Code Reviews, Agile/Scrum',
    },
];

const REPOS = [
    {
        name: 'accountability-tool',
        description:
            'Personal tracker for tasks, focus timers, notes, and flashcards — organized across three tracks: the Designer, the Engineer, and the Explorer (AI tools).',
        language: 'TypeScript',
        languageColor: '#3178c6',
        updated: 'this week',
        url: `${GITHUB_PROFILE}/accountability-tool`,
    },
    {
        name: 'freightflow',
        description:
            'Web app for logistics planners to build and optimize multi-leg freight shipments. 3-column responsive layout with AI-powered suggestions and risk assessment.',
        language: 'TypeScript',
        languageColor: '#3178c6',
        updated: 'this week',
        url: `${GITHUB_PROFILE}/freightflow`,
    },
    {
        name: 'LinkedIn-chrome-extension',
        description:
            'Chrome extension that makes LinkedIn job search less repetitive. Surfaces real posting dates on reposted jobs, auto-dismisses unwanted companies, and flags roles you already canceled at other locations.',
        language: 'JavaScript',
        languageColor: '#f1e05a',
        updated: 'this week',
        url: `${GITHUB_PROFILE}/LinkedIn-chrome-extension`,
    },
    {
        name: 'Focused-Job-Applications',
        description: 'A bot for focused job applications and outreach.',
        language: 'Python',
        languageColor: '#3572A5',
        updated: 'last month',
        url: `${GITHUB_PROFILE}/Focused-Job-Applications`,
    },
    {
        name: 'Style-guide-generator',
        description: 'Figma plugin for generating style guides.',
        language: 'TypeScript',
        languageColor: '#3178c6',
        updated: 'last year',
        url: `${GITHUB_PROFILE}/Style-guide-generator`,
    },
];

const DevPortfolio = () => {
    return (
        <section className="DevPortfolio">
            <div className="DevPortfolio__intro">
                <h1 className="DevPortfolio__heading">
                    <span className="DevPortfolio__greeting">chidrupa99</span>
                    <span className="DevPortfolio__role">// developer</span>
                </h1>
                <div className="DevPortfolio__stack">
                    {STACK.map(({ label }) => (
                        <span key={label} className="DevPortfolio__stack-pill">
                            {label}
                        </span>
                    ))}
                </div>
                <a
                    className="DevPortfolio__profile-link"
                    href={GITHUB_PROFILE}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <svg viewBox="0 0 16 16" aria-hidden="true">
                        <path fillRule="evenodd" d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0 0 16 8c0-4.42-3.58-8-8-8z" />
                    </svg>
                    github.com/{GITHUB_USERNAME}
                </a>
            </div>

            <div className="DevPortfolio__repos">
                {REPOS.map((repo) => (
                    <RepoCard key={repo.name} {...repo} />
                ))}
            </div>
        </section>
    );
};

export default DevPortfolio;
